export default __webpack_public_path__ + "static/media/Clan Bound Boots of the Mound.b2767bba.jpg";